import { React } from "react";
import { isMobile } from "react-device-detect";
import clsx from "clsx";
import MobileListVenuePage from "./MobileListVenue";
import WebListVenuePage from "./WebListVenue";
import commonStyles from "../commonStyles";
import useStyles from "./styles";

export default function ListVenuePage() {

  return (
    <>
      <div>{isMobile ? <MobileListVenuePage /> : <WebListVenuePage />}</div>
    </>
  );
}
